export enum SAP_PAYMENT_TYPE {
  'PAYMENT_FIRST' = 'PF',
  'CREDIT_TERMS' = 'CT'
};
